import type { SVGProps } from "react";
export interface Flip01LeftIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Flip01LeftIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Flip01LeftIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 13.5a3.375 3.375 0 0 0-3.375-3.375H3a1.125 1.125 0 1 1 0-2.25h13.5a5.625 5.625 0 1 1 0 11.25H11a1.125 1.125 0 0 1 0-2.25h5.5a3.375 3.375 0 0 0 3.375-3.375"
      />
      <path
        fill={color}
        d="M6.205 4.205a1.125 1.125 0 0 1 1.59 1.59L4.592 9l3.205 3.205.076.087a1.124 1.124 0 0 1-1.582 1.582l-.085-.078-4-4a1.125 1.125 0 0 1 0-1.59l4-4Z"
      />
    </svg>
  );
}
